import thunk from "redux-thunk";
import { reducers } from "../reducer";
import config from "../../../configs/sys32config";
import { createStore, applyMiddleware, compose } from "redux";
import logger from "redux-logger";

const middlewares = [thunk];

if (config.env === "development" && typeof window !== "undefined") {
  middlewares.push(logger);
}

// // function immutableChildren(obj) {
// //   const state = {}
// //   Object.keys(obj).forEach((key) => {
// //     state[key] = Immutable.fromJS(obj[key])
// //   })
// //   return state
// // }

export const initialStore = (initialState = {}, history) => {
  return createStore(
    reducers,
    initialState,
    compose(applyMiddleware(...middlewares))
  );
};
